'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loglevel = require('loglevel');

var _loglevel2 = _interopRequireDefault(_loglevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRODUCTION_STAGE = process.env.NODE_ENV !== 'production';

if (!PRODUCTION_STAGE) {
    _loglevel2.default.enableAll();
} else {
    _loglevel2.default.setLevel(_loglevel2.default.levels.WARN);
}

exports.default = _loglevel2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/aurora-javascript-utils/dist/log.js
// module id = 723
// module chunks = 118